import * as React from "react";
import { TableName } from "../TableName/TableName";
import { TableFromToHeader } from "../TableFromToHeader/TableFromToHeader";
import { TableHeaderDataCell } from "../TableHeaderDataCell/TableHeaderDataCell";
import { TableHeaderISIN } from "../TableHeaderISIN/TableHeaderISIN";

const styles = "";

interface LProps{
    headerProps?: any[];
    translations?: any;
}

export class TableHeaderRow extends React.Component<LProps, {}>{
    constructor(){
        super();
    }

    render(){
        let translations = this.props.translations, tr = [], i = 0;
        for(let p in translations){
            tr[i] = translations[p];
            i++;
        }
        let dates = this.props.headerProps;
        let asofDates = this.getDates(dates);
        let headers = this.buidlTableDataCells(asofDates);
        return(
            <tr>
                <TableName translation={tr[0]}/>
                <TableFromToHeader translation={ [tr[1], tr[2] ]}/>
                {headers}
                <TableHeaderISIN translation={tr[3]}/>
            </tr>
        );
    }

    getDates(datesArray){
        let resDates = [];
        if(Array.isArray(datesArray))
            for(let k = 0 ; k < datesArray.length ; k++){
                if(datesArray[k].statistics.values.length == 5){
                    resDates = datesArray[k].statistics.values;
                    break;
                }
            }
        return resDates;
    }

    buidlTableDataCells(asOfList){
        let resList = [];
        let date = '';
        if(asOfList.length == 5)
            for(let i=0; i<5 ;i++) {
                date = this.formatDate(asOfList[i].start_date)+'\n'+this.formatDate(asOfList[i].end_date);
                resList[i] = <TableHeaderDataCell key={i} title={ date } />
            }
        return resList;
    }

    formatDate(dateString){
        let d = new Date(dateString);
        return ( this.prefixZeroToDate(d.getDate()) + '.' + this.prefixZeroToDate(d.getMonth()+1) + '.' + d.getFullYear().toString().substr(2,2) );
    }

    prefixZeroToDate(date){
        return (date < 10) ? '0'+date : date;
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/TableHeaderRow/TableHeaderRow.tsx